import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import img1 from "../assets/img/bandeau.jpg";

export const Meditation = () => {
    return (
        <>
            <div className="banner-titre-container">
                <img src={img1} className="back-img" />
                <div className='over-banner'>
                    <div className='info-banner'>
                        <h1 className='banner-title'> Je médite, tu médites, <br /> méditons ensemble ...</h1>
                    </div>
                </div>
            </div>

            <div className='block-container bottom-space side-space-margin top-space-margin'>
                <Row>
                    <Col xs={12} lg={9}>
                        <div className='central-block central-block-margin'>
                            <h2 className='meditation-titre'>Méditation Bienfaisante</h2>
                            <h3 className='meditation-titre small-title'>Laissez-vous guider par la voix ...</h3>
                            <br /><br /><p>Lors de cette<strong> Méditation  en groupe</strong>, profitez d'un moment de détente hors du temps.
                                <strong> Éveillez votre conscience en douceur</strong> pour mieux vivre les changements énergétiques du moment.
                                <br /><br />Telle une promenade dans la Nature, la Méditation Bienfaisante <strong>ressource</strong> en profondeur et redonne motivation et espoir.
                                <br /><br />En respirant, en visualisant, en vous connectant à vos ressources profondes, votre <strong>corps </strong>et vos <strong>pensées s'apaiseront </strong>naturellement.
                                <br /><br />Imaginez-vous bénéficier des propriétés bienfaisantes des éléments  eau, air, terre, feu, vent, soleil ... Minéraux, végétaux, cristaux, couleurs aussi vous communiqueront leurs énergies subtiles et regénérantes.
                                <br /><br />La Méditation Bienfaisante et un moment de <strong>partage chaleureux </strong>où chaque besoin individuel est nourri puis enrichi d'un objectif commun : grandir intérieurement en <strong>sérénité </strong>et <strong>sagesse</strong>.</p>
                            <br />
                            <ul className="style6">
                                <li>La méditation est inspirée et toujours sur mesure</li>
                                <li>Chaque Méditation est enregistrée et retranscrite</li>
                            </ul>
                            <p className='meditation-titre'> Durée de la Méditation : 30 minutes à 60 minutes  <br /><br />
                                <strong>Exemples de thèmes : </strong><br /><br />
                                La force de la Forêt - Je retrouve mes Clés Intérieures - Estime de Soi l'Energie du Cristal - l'Energie de l'Arbre - Envie égal en Vie - Acceptation, Transformation, Lâcher-Prise <br />- Juste Temps, juste Place - Je me reconnecte avec Je Suis  - l'Energie du Coeur <br /> - Couple &amp; Intimité - Invitation à la Détente - Rencontre avec mon Guide <br /> - Le Silence de l'Etre - Onde et Particule - Ma Mission Personnelle
                                <br /><br /> <strong> Méditations disponibles sur simple demande : </strong>

                                <div className='bouton-rectangle-container'>
                                    <Link to={'/contact'} className='bouton-rectangle-music'>
                                        Me contacter
                                    </Link>
                                </div>
                            </p>
                        </div>

                    </Col>
                    <Col xs={12} lg={3}>
                        <div className='right-block'>
                            <h3 className='meditation-titre'>Calendrier</h3>
                            <div className='meditation-info'>
                                <p><strong> En Présentiel <br /> Région Parisienne</strong> <br />
                                    Méditations mensuelles <br />
                                    Le Vendredi, de 20h-21h <br />
                                </p>
                            </div>
                            <div>
                                <p> <strong><span className='text-center'>Par Visioconférence </span></strong> <br /> Méditations mensuelles<br />

                                    <br /> Me contacter pour les dates.</p>
                            </div>
                            <div className='bouton-rectangle-container'>
                                <Link to={'/contact'} className='bouton-rectangle-music'>
                                    Me contacter
                                </Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

